import { IamState, Me } from 'types/iam';
import { RootState } from 'types/root';
import { Roles } from 'utils/constants';

export const iamDetailsTree = (state: RootState): IamState => state.iam || {};

export const meDetailsIsLoading = (state: RootState): boolean => iamDetailsTree(state).isLoading || false;

export const meDetails = (state: RootState): Me => iamDetailsTree(state).me || {};
export const userKey = (state: RootState): string => meDetails(state).key || '';
export const systemRoles = (state: RootState): string[] => meDetails(state).systemRoles || [];

export const isSystemUser = (state: RootState): boolean => systemRoles(state).includes(Roles.systemUser) || false;
